import {
  fetchProductsReviews,
  productsReviewsData,
} from '~/js/utilities/products-and-collections';

const iconDefinition = /* HTML */ `<svg xmlns="http://www.w3.org/2000/svg">
  <defs>
    <symbol id="review-stars-star" viewBox="0 0 9 9">
      <path
        d="M6.42,2.63l2.05,.32c.34,.05,.57,.37,.52,.71-.02,.13-.08,.25-.17,.34l-1.52,1.57c-.14,.14-.2,.34-.17,.54l.35,2.18c.06,.34-.17,.66-.51,.72-.14,.02-.28,0-.4-.07l-1.78-.99c-.19-.1-.41-.1-.6,0l-1.78,.99c-.3,.17-.68,.06-.84-.24-.07-.12-.09-.26-.07-.4l.35-2.18c.03-.2-.03-.39-.17-.54L.18,3.99c-.24-.25-.23-.64,.01-.88,.09-.09,.21-.15,.34-.17l2.05-.32c.2-.03,.38-.16,.47-.35L3.94,.36c.15-.31,.51-.45,.82-.3,.13,.06,.24,.17,.3,.3l.89,1.92c.09,.19,.26,.32,.47,.35Z"
      />
    </symbol>
  </defs>
</svg>`;

let setupDone = false;
const setup = () => {
  if (setupDone) return;
  setupDone = true;

  const div = document.createElement('div');
  div.style.display = 'none'; // TODO: validate across browsers
  div.innerHTML = iconDefinition;
  document.body.append(div);
};

const reviewStars = (context) => ({
  loading: false,

  get showWhenZeroReviews() {
    return context === 'hero-product-info';
  },

  get reviewsData() {
    if (!this.shopifyData) return null;
    if (this.loading) return null;
    return productsReviewsData[this.shopifyData.id];
  },

  get label() {
    const rating = this.reviewsData?.rating || 0;
    const ratingNormalized = Number(rating) || 0;
    if (ratingNormalized === 0) return '';
    return `Rated ${ratingNormalized.toFixed(1)} out of 5 stars`;
  },

  get reviewsText() {
    const count = this.reviewsData?.count || 0;
    return `${count} Review${count === 1 ? '' : 's'}`;
  },

  get filledWidth() {
    const rating = this.reviewsData?.rating || 0;
    const starWidth = 9;
    const spacingWidth = 3.5;
    const totalWidth = starWidth * 5 + spacingWidth * 4;
    const starFraction = starWidth / totalWidth;
    const spacingFraction = spacingWidth / totalWidth;
    const widthFraction =
      rating * starFraction + spacingFraction * Math.floor(rating);
    return `${widthFraction * 100}%`;
  },

  init() {
    if (!this.shopifyData) return;

    setup();

    if (!this.reviewsData) {
      this.loading = true;
      fetchProductsReviews([this.shopifyData.id]).then(() => {
        this.loading = false;
      });
    }
  },
});

export default reviewStars;
